import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router";
import { useAuthState } from "../../adapters/insights-agent/state/hooks/stateHooks.ts";
import { useAppName } from "../../adapters/insights-agent/state/hooks/useAppName.ts";
import { useInsightsAgentService } from "../../adapters/insights-agent/state/hooks/useInsightsAgentService.tsx";
import { useConfig } from "../../adapters/insights-agent/state/hooks/useConfig.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { Header } from "../../feature-components/Header/Header.tsx";
import { Login } from "../../feature-components/Login/Login.tsx";

export const LoginPage = () => {
  const navigate = useNavigate();
  const authState = useAuthState();
  const config = useConfig();
  const enableGlobalNav = useFeatureFlagValue("enableGlobalNav");
  const appService = useInsightsAgentService();
  const enablePasswordlessLogin = useFeatureFlagValue(
    "enablePasswordlessLogin",
  );

  useEffect(() => {
    if (authState === "authenticated") {
      navigate("/workflows/new");
    }
  }, [authState, navigate]);

  const onSignInWithMicrosoft = useMemo(() => {
    return async () => {
      await appService.authService.loginWithMicrosoft();
      navigate("/workflows/new");
    };
  }, [appService.authService, navigate]);

  const onSignInWithPasswordless = useMemo(() => {
    if (!enablePasswordlessLogin) return;
    return async (email: string) =>
      await appService.authService.submitMagicLink(email);
  }, [appService.authService, enablePasswordlessLogin]);

  return (
    <>
      <Header
        isAuthenticated={false}
        enableGlobalNav={enableGlobalNav}
        env={config.environment}
        appTitle={useAppName()}
      />
      <Login
        onSignInWithMicrosoft={onSignInWithMicrosoft}
        onSignInWithPasswordless={onSignInWithPasswordless}
      />
    </>
  );
};
